import gsap from 'gsap';
import { initPopover } from './Popover';

export const initPopoverAnimation = tl => {
    const header = document.querySelector('#header');
    const popover = document.querySelector('#appointment');

    if (!header || !popover) return;

    gsap.set(popover.querySelector('.c-content'), { y: '3rem' });

    tl.to(
        [header, '#hero-content, #hero-blur, #hero .read-more'],
        { duration: 1, autoAlpha: 0, visibility: 'hidden' },
        0
    )
        .to(popover, { duration: 1, autoAlpha: 1, display: 'flex' }, 0)
        .to(popover.querySelector('.c-content'), { duration: 1.5, y: 0 }, 0);

    initPopover(tl);
};
